import { useEffect, useState } from 'react'

import './UserAlerts.scss'
import { BannerType, BannerVariaion } from '@cox/core-ui8/dist/Banner'
import { ButtonTypes } from '@cox/core-ui8/dist/Button'
import { Spinner } from '@cox/core-ui8/dist/Spinner'
import { visitorLoginStatus } from '@cox/core-ui8/dist/types'
import { useUdoContext } from '@cox/core-ui8/dist/UdoContext'
import axios from 'axios'

import { WEB_APIS } from '../../../constants'
import { setAPIDispositionState } from '../../../services/index'
import ReactBanner from '../../ReactBanner'
import ReactButton from '../../ReactButton'
import { AlertProp, DispositionItemProp, DispositionRequest, ReactUserAlertsProps } from '../types'

const UserAlerts = (props: ReactUserAlertsProps) => {
  const {
    count = -1,
    heading = '',
    signinMessage = '',
    loadingMessage = '',
    clearMessage = '',
    noAlertsMessage = '',
    bannerVariation = BannerVariaion.DEFAULT_BORDERED,
    text = '',
    linkUrl = '',
    className = '',
    isInEditor = false
  } = props

  const [userAlerts, setUserAlerts] = useState<AlertProp[]>([])
  const [totalAlerts, setTotalAlerts] = useState(0)
  const [loading, setLoading] = useState(false)

  const { udo } = useUdoContext()
  const isLoggedIn = udo?.visitorLoginStatus === visitorLoginStatus.LOGGEDIN

  const fetchAlerts = async () => {
    setLoading(true)
    try {
      const response = await axios.get(`${WEB_APIS.USER_ALERTS_API}${count}`, {
        withCredentials: true
      })
      return response?.data
    } catch (error) {
      console.error(error)
    }
  }

  const sendDisposition = (alertList: Array<AlertProp>, dispositionType: DispositionItemProp['Type']) => {
    if (alertList && alertList.length > 0) {
      const dispositionList: DispositionItemProp[] = alertList.map((alert) => ({
        PropositionID: alert.id,
        PropositionDescription: alert.message,
        Type: dispositionType,
        DateTime: new Date().toISOString()
      }))

      const request: DispositionRequest = {
        InteractionID: alertList[0]?.interactionId || '',
        count: count,
        dispositionfor: 'alerts',
        DispositionList: dispositionList
      }
      setAPIDispositionState(request, count)
    }
  }
  const handleAccept = (alert: AlertProp) => {
    sendDisposition([alert], 'ACCEPTED')
  }

  const handleDismiss = (alert: AlertProp) => {
    sendDisposition([alert], 'DECLINED')
    setUserAlerts((prev) => prev.filter((a) => a.id !== alert.id))
    setTotalAlerts((prev) => prev - 1)
  }

  const handleClick = (e: any, id: any) => {
    const tagName = e.target.tagName.toLowerCase()
    const index = userAlerts.findIndex((alert) => alert.id === id)
    const alert = userAlerts[index]
    if (tagName === 'a') {
      handleAccept(alert)
    }
    if (tagName === 'img' && e.target.classList.contains('banner__close-btn-icon')) {
      handleDismiss(alert)
    }
  }

  const handleClearAlerts = () => {
    const remainingAlerts = userAlerts.filter((alert) => !alert.suppressionEnabled)
    const clearedAlerts = userAlerts.filter((alert) => alert.suppressionEnabled)
    setUserAlerts(remainingAlerts)
    setTotalAlerts(remainingAlerts.length)
    sendDisposition(clearedAlerts, 'DECLINED')
  }

  useEffect(() => {
    if (isLoggedIn) {
      fetchAlerts()
        .then((data) => {
          const { totalAlerts = 0 } = data
          const allAlerts = [...(data.accountAlerts || []), ...(data.recommendationAlerts || [])]
          setTotalAlerts(totalAlerts)
          setUserAlerts(allAlerts)
          setLoading(false)
          sendDisposition(allAlerts, 'VIEWED')
        })
        .catch((error: Error) => {
          console.error('User Alerts Error: ', error)
          setTotalAlerts(0)
          setUserAlerts([])
          setLoading(false)
        })
    }
  }, [])

  const renderContent = () => {
    if (!isLoggedIn || isInEditor) {
      return (
        <>
          <div className='user-alerts__signin'>
            <p>{signinMessage}</p>
          </div>
          <ReactButton text={text} buttonTypes={ButtonTypes.PRIMARY} linkUrl={linkUrl} />
        </>
      )
    }
    if (loading) {
      return (
        <>
          <div className='user-alerts__loading'>
            <p>{loadingMessage}</p>
          </div>
          <Spinner size='lg' color='gradient' />
        </>
      )
    }
    if (userAlerts.length === 0) {
      return (
        <div className='user-alerts__no-alerts'>
          <p>{noAlertsMessage}</p>
        </div>
      )
    }
    return (
      <div className='user-alerts__clear' onClick={handleClearAlerts}>
        <p>{clearMessage}</p>
      </div>
    )
  }

  return (
    <div className={`user-alerts ${className}`}>
      <div className='user-alerts__header'>
        <div className='user-alerts__heading'>
          <h1>{`${heading.trim()} (${totalAlerts})`}</h1>
        </div>
        {renderContent()}
      </div>
      <div className='user-alerts__list'>
        {userAlerts.map((alert: AlertProp) => (
          <div className='user-alerts__list-item' key={alert.id} onClick={(e) => handleClick(e, alert.id)}>
            <ReactBanner
              bannerType={BannerType.DYNAMIC}
              variations={bannerVariation}
              key={alert.id}
              message={alert.message}
              openInNewTab={false}
              isDismissable={alert.suppressionEnabled}
            />
          </div>
        ))}
      </div>
    </div>
  )
}

export default UserAlerts
